module.exports = __webpack_public_path__ + "img/relax.f8916671.png";